import { render, staticRenderFns } from "./casedata.vue?vue&type=template&id=528167e0&scoped=true"
import script from "./casedata.vue?vue&type=script&lang=js"
export * from "./casedata.vue?vue&type=script&lang=js"
import style0 from "./casedata.vue?vue&type=style&index=0&id=528167e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528167e0",
  null
  
)

export default component.exports